<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <app-datatable
    [columns]="columns"
    [rows]="ranklistRows"
    [searchControlSettings]="searchControlSettings"
    (filterChange)="onFilterChange($event)"
    [initialFilters]="filters"
    [isTopSection]="true"
    [isCustomFooter]="true"
  ></app-datatable>
</nb-card>
